/**
 * @packageDocumentation
 * @module f1/abstract-data-type
 */

import fold from './fold';
import { t_rec_arr, t_key, t_rec, t_arr } from '../types';

type t_each_fn<V> = (v: V, k: t_key, adt: t_rec_arr<V>) => void;

export interface Each {
  /**
   * @public
   * @function f1.each
   * @param adt the array or record we will compact
   * @example
   *
   * ```ts
   * f1.each((v) => {
   *   console.log(v);
   * }, []) === []
   * ```
   *
   */
  <V>(fn: t_each_fn<V>, adt: t_arr<V>): t_arr<V>;
  <V>(fn: t_each_fn<V>, adt: t_rec<string, V>): t_rec<string, V>;
  <V>(fn: t_each_fn<V>, adt: t_rec_arr<V>): t_rec_arr<V>;

  // <V>(fn: t_each_fn<V>): (adt: t_arr<V>) => t_arr<V>;
  // <V>(fn: t_each_fn<V>): (adt: t_rec<string, V>) => t_rec<string, V>;
  <V>(fn: t_each_fn<V>): (adt: t_rec_arr<V>) => t_rec_arr<V>;
}

/**
 * @see Each
 */
export default <V>(fn: t_each_fn<V>, adt: t_rec_arr<V>): t_rec_arr<V> => {
  return fold(
    (acc, v, k, adt) => {
      fn(v, k, adt);
      return acc;
    },
    adt,
    adt
  );
};
